export {default as OpaccDateRangePicker} from './flatpickr.js';